module.exports = __webpack_public_path__ + "img/check.9020aa99.png";